const FOR_SALE = 'for-sale';
const FOR_RENT = 'for-rent';
const FOR_HOLIDAY = 'for-holidays';

const RuleTypeDescription = 'description';
const RuleTypeImage = 'image';
const RuleTypeFeature = 'feature';
const RuleTypeAttribute = 'attribute';
const RuleTypeLocation = 'location';
const RuleTypeMedia = 'media';

const ruleTypes = [
    RuleTypeAttribute,
    RuleTypeDescription,
    RuleTypeImage,
    RuleTypeFeature,
    RuleTypeLocation,
    RuleTypeMedia
];

const RuleScopeProperty = 'property';
const RuleScopeLogin = 'login';

const ruleScopes = [
    RuleScopeProperty,
    RuleScopeLogin
];

const StatusInReview = 'in-review';
const StatusReviewed = 'reviewed';
const StatusPending = 'pending';
const StatusDoNotReview = 'do-not-review';
const StatusReReview = 're-review';

const PropertyStatusOnline = 'online';
const PropertyStatusOffline = 'offline';
const PropertyStatusAll = 'all';

export {
    FOR_HOLIDAY,
    FOR_SALE,
    FOR_RENT,
    RuleTypeAttribute,
    RuleTypeDescription,
    RuleTypeImage,
    RuleTypeFeature,
    RuleTypeLocation,
    RuleTypeMedia,
    RuleScopeProperty,
    RuleScopeLogin,
    StatusInReview,
    StatusReviewed,
    StatusPending,
    StatusDoNotReview,
    StatusReReview,
    PropertyStatusOnline,
    PropertyStatusOffline,
    PropertyStatusAll,
    ruleTypes,
    ruleScopes
};



// WEBPACK FOOTER //
// ./src/components/property-qc/consts.js